import { $ } from 'utils/dom';

const hero = $('.landingpage-hero');

if (hero) {
  const media = $('.landingpage-hero__media', hero);
  const headlineTop = $('h1', hero);
  const headlineBottom = $('h2', hero);
  const paragraph = $('.landingpage-hero__text', hero);

  window.addEventListener('load', event => {
    setTimeout(() => {
      media.classList.add('animate-in');
    }, 200);
    setTimeout(() => {
      headlineTop.classList.add('animate-in');
    }, 800);
    setTimeout(() => {
      headlineBottom.classList.add('animate-in');
    }, 2200);
    setTimeout(() => {
      paragraph.classList.add('animate-in');
    }, 3200);
  });
}
